// Copyright (c) 2022 by Move Closer

import { AsyncComponent } from 'vue'
import { AnyObject } from '@movecloser/front-core'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum NewsletterModuleVersion {
  Default = 'default',
  Rich = 'rich',
  Extended = 'extended',
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const NEWSLETTER_MODULE_KEY = 'NewsletterModule'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface NewsletterModuleConfig {
  alertButtonTheme: string
  buttonHasLabel: boolean
  buttonIcon: string
  buttonTheme: string
  consents: AnyObject[]
  consentsDescription: Record<string, string> | null
  layout: string
  useExtendedConsents: boolean
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const NEWSLETTER_MODULE_CONFIG_MAP: NewsletterModuleConfig = {
  alertButtonTheme: 'primary',
  buttonHasLabel: true,
  buttonIcon: '',
  buttonTheme: 'primary',
  consents: [],
  consentsDescription: null,
  layout: NewsletterModuleVersion.Extended,
  useExtendedConsents: false
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const newsletterModuleVersionsRegistry: Record<string, AsyncComponent> = {
  [NewsletterModuleVersion.Default]: () => import(
    /* webpackChunkName: "modules/NewsletterDefault" */
    './versions/Default.vue'
  ),
  [NewsletterModuleVersion.Rich]: () => import(
    /* webpackChunkName: "modules/NewsletterRich" */
    './versions/Rich.vue'
  ),
  [NewsletterModuleVersion.Extended]: () => import(
    /* webpackChunkName: "modules/NewsletterForm" */
    './versions/Extended.vue'
  )
}
